import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import 'bootstrap-icons/font/bootstrap-icons.css';
import Navbar from "./components/Navbar/Navbar";
import Main from "./layout/Main";
import Footer from './components/Footer/Footer'
import ScrollOnNavigate from "./components/ScrollOnNavigate/ScrollOnNavigate";
import { ApiProvider } from "./contexts/ApiContext";

const AppContent: React.FC = () => {
  return (
    <div className="app-container">
      <ScrollOnNavigate />
      <Navbar />
      <Main />
      <Footer />
    </div>
  );
};

const App: React.FC = () => {
  return (
    <Router>
      <ApiProvider>
        <AppContent />
      </ApiProvider>
    </Router>
  );
};

export default App;